import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Importa useAuth

// Componente PrivateRoute para react-router-dom v6
const PrivateRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth(); // Obtiene el estado de autenticación y carga del contexto

    // Muestra un mensaje de carga mientras se verifica el token
    if (loading) {
        return <div>Cargando autenticación...</div>; 
    }

    // Si está autenticado, renderiza los componentes hijos
    if (isAuthenticated) {
        return children; 
    } else {
        // Redirige a la página de login.
        // Pasa la ubicación actual en el estado para posible redirección después del login.
        return <Navigate to="/login" state={{ from: window.location.pathname }} replace />;
    }
};

export default PrivateRoute;
